import { Component, ComponentFactoryResolver } from '@angular/core';
import { Router } from '@angular/router';

import { ModalService } from '../../services/modal/modal.service';
import { ModalType } from '../../../js/interfaces/CoverpathTypes';
import { ScheduleMedicalExamComponent } from '../../../../coverpath-client/public/js/components/shared/modal/schedule-medical-exam/schedule-medical-exam.component';
import { ConvertPolicyComponent } from '../../../../coverpath-client/public/js/components/shared/modal/convert-policy/convert-policy.component';
import { ChangeDividendOptionComponent } from '../../../../coverpath-client/public/js/components/shared/modal/change-dividend-option/change-dividend-option.component';
import { CancelPolicyComponent } from '../../../../coverpath-client/public/js/components/shared/modal/cancel-policy/cancel-policy.component';
import { BeneWidgetComponent } from '../../../../common/widgets/bene-widget/js/components/app-component/app.component';
import { CancelPolicySimpleComponent } from '../../../../coverpath-client/public/js/components/shared/modal/cancel-policy-simple/cancel-policy-simple.component';
import { BeneWidgetComponentSplit } from '../../../../coverpath-client/public/js/components/shared/modal/bene-widget-split/bene-widget-split.component';
import { PaymentUpdateComponent } from '../../../../common/widgets/payment-update-widget/js/customer/components/app-component/app.component';
import { PaymentUpdateComponentSplit } from '../../../../coverpath-client/public/js/components/shared/modal/payment-update-split/payment-update-split.component';
import { PolicyDocsComponentSplit } from '../../../../coverpath-client/public/js/components/shared/modal/policy-docs-split/policy-docs-split.component';
import { ContactWidgetCoverpathComponent } from '../../../../common/widgets/contact-update-widget/component/contact-widget-component/contact-widget-coverpath.component';
import { ContactWidgetMmDirectComponent } from '../../../../common/widgets/contact-update-widget/component/contact-widget-component/contact-widget-mmdirect.component';
import { ContactUpdateComponentCoverpathSplit } from '../../../../coverpath-client/public/js/components/shared/modal/contact-update-split/contact-update-split.component';

import {
  LoadingModalComponent,
  GenericModalComponent,
  MultiActionModalComponent,
  PremiumBreakdownModalComponent,
  UnsupportedCasesComponent,
  UseCasesWithMessageComponent,
  ReplacementComponent,
  PaymentIfMissingContainerComponent,
  PaymentIfMissingPolicyInfoComponent,
  DocumentUploadComponent,
  ClientEsignModalComponent,
  GroupReplacementComponent,
  SignerEmailComponent,
  DeclineTLICConfirmationComponent,
  ReplacementALIR1035Component,
  CheckLegalGuardianComponent,
  ConfirmLegalGuardianComponent,
  EditSignerNameComponent,
  ClientConversionEsignModalComponent,
  AuthorizePaymentComponent,
} from './shared-modal-components';
import { ModalContainerBase } from './modal-container.base';
import { EsignModalComponent } from '../../../components/esign-modal/esign-modal.component';
import { PaymentModalComponent } from './payment/payment-modal.component';
import { ChangeSanderlingDetailComponent } from '../../../../coverpath-client/public/js/components/shared/modal/change-sanderling-detail/change-sanderling-detail.component';

// Modals

export const ModalComponents = [
  LoadingModalComponent,
  GenericModalComponent,
  MultiActionModalComponent,
  PremiumBreakdownModalComponent,
  ScheduleMedicalExamComponent,
  ConvertPolicyComponent,
  ChangeDividendOptionComponent,
  ChangeSanderlingDetailComponent,
  CancelPolicyComponent,
  CancelPolicySimpleComponent,
  UnsupportedCasesComponent,
  UseCasesWithMessageComponent,
  ReplacementComponent,
  PaymentUpdateComponentSplit,
  PaymentIfMissingContainerComponent,
  PaymentIfMissingPolicyInfoComponent,
  BeneWidgetComponentSplit,
  ContactUpdateComponentCoverpathSplit,
  PolicyDocsComponentSplit,
  DocumentUploadComponent,
  ClientEsignModalComponent,
  GroupReplacementComponent,
  SignerEmailComponent,
  DeclineTLICConfirmationComponent,
  ReplacementALIR1035Component,
  EsignModalComponent,
  PaymentModalComponent,
  CheckLegalGuardianComponent,
  ConfirmLegalGuardianComponent,
  EditSignerNameComponent,
  ClientConversionEsignModalComponent,
  AuthorizePaymentComponent,
];

@Component({
  moduleId: module.id,
  selector: 'modal-hl',
  entryComponents: [ModalComponents],
  templateUrl: './modal-container.component.html',
  host: {
    '(document:keydown)': 'keyDownPress($event)',
  },
})
export class ModalContainerComponent extends ModalContainerBase {
  constructor(modalService: ModalService, private componentFactoryResolver: ComponentFactoryResolver, router: Router) {
    super(modalService, router);
  }

  ngOnInit() {
    super.initialize();
  }

  resolveModalType(modalType: ModalType) {
    if (this.componentInstance) {
      this.destroyComponent();
    }
    let component;
    switch (modalType) {
      case ModalType.accountAlreadyExists:
        component = this.componentFactoryResolver.resolveComponentFactory(MultiActionModalComponent);
        break;
      case ModalType.clientEsign:
        component = this.componentFactoryResolver.resolveComponentFactory(ClientEsignModalComponent);
        break;
      case ModalType.loadingTOAdvisorAssistantApplication:
      case ModalType.cpAgentLoading:
        component = this.componentFactoryResolver.resolveComponentFactory(LoadingModalComponent);
        break;
      case ModalType.generic:
      case ModalType.applicationPreviouslySent:
      case ModalType.applicationAlreadyEsignedByAdvisor:
      case ModalType.applicationAlreadyCanceledByClientWhenAdvisorEsign:
      case ModalType.agentSubmission:
      case ModalType.agentSubmissionFailed:
      case ModalType.completeApplicationForm:
      case ModalType.advisorProcessingApplicationForm:
      case ModalType.policyDocRetrievalFailed:
      case ModalType.policyReplacementThankYou:
      case ModalType.otherCompanyReplacementWarning:
      case ModalType.advisorAppIncomplete:
      case ModalType.lockedQuestionIncomplete:
        component = this.componentFactoryResolver.resolveComponentFactory(GenericModalComponent);
        break;
      case ModalType.premiumBreakdown:
        component = this.componentFactoryResolver.resolveComponentFactory(PremiumBreakdownModalComponent);
        break;
      case ModalType.scheduleMedicalExam:
        component = this.componentFactoryResolver.resolveComponentFactory(ScheduleMedicalExamComponent);
        break;
      case ModalType.convertPolicy:
        component = this.componentFactoryResolver.resolveComponentFactory(ConvertPolicyComponent);
        break;
      case ModalType.changeDividendOption:
        component = this.componentFactoryResolver.resolveComponentFactory(ChangeDividendOptionComponent);
        break;
      case ModalType.changeSanderlingDetail:
        component = this.componentFactoryResolver.resolveComponentFactory(ChangeSanderlingDetailComponent);
        break;
      case ModalType.cancelPolicy:
        component = this.componentFactoryResolver.resolveComponentFactory(CancelPolicyComponent);
        break;
      case ModalType.cancelPolicySimple:
        component = this.componentFactoryResolver.resolveComponentFactory(CancelPolicySimpleComponent);
        break;
      case ModalType.unsupportedCases:
        component = this.componentFactoryResolver.resolveComponentFactory(UnsupportedCasesComponent);
        break;
      case ModalType.useCaseWithMessage:
        component = this.componentFactoryResolver.resolveComponentFactory(UseCasesWithMessageComponent);
        break;
      case ModalType.policyReplacement:
        component = this.componentFactoryResolver.resolveComponentFactory(ReplacementComponent);
        break;
      case ModalType.beneWidget:
        component = this.componentFactoryResolver.resolveComponentFactory(BeneWidgetComponent);
        break;
      case ModalType.paymentIfMissing:
        component = this.componentFactoryResolver.resolveComponentFactory(PaymentIfMissingContainerComponent);
        break;
      case ModalType.bankInfo:
        component = this.componentFactoryResolver.resolveComponentFactory(PaymentUpdateComponent);
        break;
      case ModalType.beneWidgetJointSplit:
        component = this.componentFactoryResolver.resolveComponentFactory(BeneWidgetComponentSplit);
        break;
      case ModalType.bankInfoJointSplit:
        component = this.componentFactoryResolver.resolveComponentFactory(PaymentUpdateComponentSplit);
        break;
      case ModalType.contactWidgetJointSplit:
        component = this.componentFactoryResolver.resolveComponentFactory(ContactUpdateComponentCoverpathSplit);
        break;
      case ModalType.contactWidget:
        component = this.componentFactoryResolver.resolveComponentFactory(ContactWidgetCoverpathComponent);
        break;
      case ModalType.policyDocsJointSplit:
        component = this.componentFactoryResolver.resolveComponentFactory(PolicyDocsComponentSplit);
        break;
      case ModalType.contactWidgetMmDirect:
        component = this.componentFactoryResolver.resolveComponentFactory(ContactWidgetMmDirectComponent);
        break;
      case ModalType.documentUpload:
        component = this.componentFactoryResolver.resolveComponentFactory(DocumentUploadComponent);
        break;
      case ModalType.groupReplacement:
        component = this.componentFactoryResolver.resolveComponentFactory(GroupReplacementComponent);
        break;
      case ModalType.signerEmail:
        component = this.componentFactoryResolver.resolveComponentFactory(SignerEmailComponent);
        break;
      case ModalType.declineTLICConfirm:
        component = this.componentFactoryResolver.resolveComponentFactory(DeclineTLICConfirmationComponent);
        break;
      case ModalType.esignModal:
        component = this.componentFactoryResolver.resolveComponentFactory(EsignModalComponent);
        break;
      case ModalType.paymentModal:
        component = this.componentFactoryResolver.resolveComponentFactory(PaymentModalComponent);
        break;
      case ModalType.ALIR1035:
        component = this.componentFactoryResolver.resolveComponentFactory(ReplacementALIR1035Component);
        break;
      case ModalType.checkLegalGuardian:
        component = this.componentFactoryResolver.resolveComponentFactory(CheckLegalGuardianComponent);
        break;
      case ModalType.confirmLegalGuardian:
        component = this.componentFactoryResolver.resolveComponentFactory(ConfirmLegalGuardianComponent);
        break;
      case ModalType.editSignerName:
        component = this.componentFactoryResolver.resolveComponentFactory(EditSignerNameComponent);
        break;
      case ModalType.clientConversionEsign:
        component = this.componentFactoryResolver.resolveComponentFactory(ClientConversionEsignModalComponent);
        break;
      case ModalType.AuthorizePayment:
        component = this.componentFactoryResolver.resolveComponentFactory(AuthorizePaymentComponent);
        break;
      default:
        this.destroyComponent();
        break;
    }
    this.componentInstance = this.modalRef.createComponent(component);
  }
}
